// extracted by mini-css-extract-plugin
module.exports = {"sectionLabel":"GroupSettingsMembersSection_sectionLabel_oyUYn","groupMemberListContainer":"GroupSettingsMembersSection_groupMemberListContainer_2UIcp"};